export const getPlaceholderContent = (node, parent) => {
    var _a;
    const content = ((_a = node.type.spec.placeholder) === null || _a === void 0 ? void 0 : _a.content) || '';
    return typeof content === 'function' ? content(node, parent) : content;
};
